<template>
  <base-container>
    <van-cell-group style="margin-top:7px;">
      <van-field v-model="info.waterNo" placeholder="请输入客户代码" label="客户代码">
        <template #button>
          <van-icon name="more" color="#1989fa" @click="toSelWater" />
        </template>
      </van-field>
      <van-cell v-if="waterName" title="客户姓名" :value="waterName" />
      <van-cell title="客户分组" is-link :value="info.groupName" @click="showGroup=true"></van-cell>
    </van-cell-group>
    <van-popup position="bottom" style="height:50%;" v-model="showWater">
      <van-picker
        title="请选择客户代码"
        show-toolbar
        :columns="waterInfos"
        :loading="isLoadWater"
        @confirm="selWater"
        @cancel="showWater=false"
      />
    </van-popup>
    <van-popup position="bottom" style="height:50%;" v-model="showGroup">
      <van-picker
        title="请选择分组"
        show-toolbar
        :columns="groups"
        @confirm="selGroup"
        @cancel="showGroup=false"
      />
    </van-popup>
  </base-container>
</template>

<script>
import { getUserInfo } from "@/api/customer";
import {isNullOrEmpty} from "@/util/util";
export default {
  data() {
    return {
      showGroup: false,
      groups: ["我家", "父母", "房东", "朋友", "其他"],
      info: {
        waterNo: "",
        groupName: "我家",
      },
      showWater: false,
      isLoadWater: true,
      waterInfos: [],
    };
  },
  computed: {
    waterName() {
      let wn = "";
      if (this.info.waterNo) {
        let water = this.waterInfos.find((c) => c.key == this.info.waterNo);
        if (water) wn = water.waterName;
      }
      return wn;
    },
  },
  watch: {
    info: {
      handler: function () {
        this.$emit("water-confirm", this.info);
      },
      deep: true,
    },
  },
  methods: {
    selGroup(name) {
      this.info.groupName = name;
      this.showGroup = false;
    },
    selWater(val) {
      this.info.waterNo = val.key;
      this.info.groupName = val.groupName;
      this.showWater = false;
    },
    toSelWater() {
      this.showWater = true;
      if (this.waterInfos.length == 0) {
        getUserInfo()
          .then((res) => {
            res.data.value.cusWaterfeeInfos.forEach((item) => {
              console.log(item.groupName);
              let label = item.waterNo + "-" + item.waterName;
              if (!isNullOrEmpty(item.groupName)) label += "-" + item.groupName;
              this.waterInfos.push({
                key: item.waterNo,
                text: label,
                groupName: item.groupName,
                waterName: item.waterName,
              });
            });
            this.isLoadWater = false;
          })
          .catch(() => {
            this.isLoadWater = false;
          });
      }
    },
  },
};
</script>

<style>
</style>